
const ToggleButtonComponent = {
    template: require('./toggle-button.html'),
    restrict: 'E',
    controllerAs: 'vm',
    bindings: {
        onOff: '<'
    }
};

export default ToggleButtonComponent;
